// extracted by mini-css-extract-plugin
export default {"arrows":"DateSwitcher_arrows__89KKa","container":"DateSwitcher_container__vjQGm","dateButton":"DateSwitcher_dateButton__LBsk3"};